/*
 * 新規登録ページへのリンク関連
 */
import { stringify } from '@/utils/libs/query-string/stringify';
import { REGISTRATION_TYPE_NORMAL, REGISTRATION_TYPE_COLUMN, REGISTRATION_TYPE_DOCUMENT, REGISTRATION_TYPE_CONSULTANT_SEARCH, REGISTRATION_TYPE_PROFESSIONAL_ONE, REGISTRATION_TYPE_PROFESSIONAL_UNIT, } from '@/utils/resources/registration/registrationType';
import { registrationPath } from '@/utils/router/links';
/**
 * 新規登録ページへのリンク取得
 */
export const getRegistrationLink = () => {
    const { href: ref, pathname } = window.location;
    const path = pathname.replace(/\/$/, '');
    // 登録経路の種別を判定
    let { type } = [
        { route: '/column/', type: REGISTRATION_TYPE_COLUMN },
        { route: '/document', type: REGISTRATION_TYPE_DOCUMENT },
        {
            route: '/consultant_unit/',
            type: REGISTRATION_TYPE_PROFESSIONAL_UNIT,
        },
        {
            route: '/consultant/search',
            type: REGISTRATION_TYPE_CONSULTANT_SEARCH,
        },
        { route: '/consultant/', type: REGISTRATION_TYPE_PROFESSIONAL_ONE },
    ].find((v) => path.indexOf(v.route) === 0) || {};
    if (!type) {
        type = REGISTRATION_TYPE_NORMAL;
    }
    return `${registrationPath()}?${stringify({ ref, type })}`;
};
